<template>
  <v-snackbar
    :value="value"
    :timeout="timeout"
    bottom
    multi-line
    right
    :color="color"
    @input="updateValue($event)"
  >
    <span v-html="text"></span>

    <v-spacer />

    <template #action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="closeSnackbar"
      >
        Fermer
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Snackbar',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number,
      default: 5000
    },
    color: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value);
    },
    closeSnackbar () {
      this.$emit('input', false);
    }
  }
};
</script>
